import { useAppSelector, useAppDispatch } from '../store/hooks';
import { useAuth0 } from '@auth0/auth0-react';
import {
  signOut as signOutThunk,
  handleResendVerification as handleResendVerificationThunk,
  handleRetryAfterVerification as handleRetryAfterVerificationThunk,
  handleAcknowledge as handleAcknowledgeThunk,
} from '../store/thunks/authThunks';
import { useResendVerificationEmail, useSignIn, useEvalToken, useSignOut, useAcknowledgeTerms } from './auth/useAuthClient';

export const useAuth = () => {
  const dispatch = useAppDispatch();
  const authState = useAppSelector((state) => state.auth);
  const {
    user: auth0User,
    isAuthenticated: auth0IsAuthenticated,
    logout: auth0Logout,
    getAccessTokenSilently,
  } = useAuth0();
  const resendVerificationEmail = useResendVerificationEmail();
  const signIn = useSignIn();
  const evalToken = useEvalToken();
  const apiSignOut = useSignOut();
  const acknowledgeTerms = useAcknowledgeTerms();

  const isAuthenticated =
    authState.isAuthenticated &&
    !authState.showEmailVerification &&
    !authState.showPersonnelNotFound &&
    !authState.showAcknowledgement;

  return {
    user: authState.user,
    sessionId: authState.sessionId,
    auth0User: authState.auth0User || auth0User,
    whoamiData: authState.whoamiData,

    isAuthenticated,
    isLoading: authState.isLoading,
    backendSignInError: authState.backendSignInError,
    showEmailVerification: authState.showEmailVerification,
    showPersonnelNotFound: authState.showPersonnelNotFound,
    showAcknowledgement: authState.showAcknowledgement,
    isSigningOut: authState.isSigningOut,

    signOut: () =>
      dispatch(signOutThunk(auth0Logout, auth0IsAuthenticated, apiSignOut)),
    handleResendVerification: () =>
      dispatch(
        handleResendVerificationThunk(
          authState.pendingAccessToken,
          resendVerificationEmail,
          getAccessTokenSilently,
          auth0IsAuthenticated
        )
      ),
    handleRetryAfterVerification: () =>
      dispatch(
        handleRetryAfterVerificationThunk(
          authState.pendingAccessToken,
          authState.auth0User || auth0User,
          signIn,
          evalToken
        )
      ),
    handleAcknowledge: () => dispatch(handleAcknowledgeThunk(acknowledgeTerms)),

    signinResponse: authState.signinResponse,
    auth0Error: authState.auth0Error,
    pendingAccessToken: authState.pendingAccessToken,
  };
};
